import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogPostDateInterface } from 'common/types/entities/BlogPostDateInterface'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createBlogPostDate(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): BlogPostDateInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.BlogPostDate, parentId, masterBlockId),
    fontSize: 16,
    color: 'rgba(0, 0, 0, 1)',
    mobileFontSize: 16,
    alignSelf: 'left',
  }
}
